<template>
    <mm-select :options="options"
    v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
export default {
	data(){
		const options = [
							['adv_id','Adverister'],
							['networkid','Channel'],
							['offerid','Offer'],
							['sub_channel','Sub Channel(APP ID)'],
						].map(v => {
			return { value: v[0], label: v[1] };
		});
		return{
			options,
		}
	},
	props:['value'],
}
</script>

